import { connect } from 'react-redux';
import { getCurrentStation, getIsPlaying, getUseHD } from 'store/reducers/player';

import PlayerHDAudio from './PlayerHDAudio';
import { getIsLoggedIn, getUserPrefersHDSources } from 'store/reducers/user';

import { loadStation, setPlaybackToLiveAudio } from 'actions/player-actions';
import { setUserHDPreference } from 'actions/gigya-actions';

const mapStateToProps = (state) => ({
  currentStation: getCurrentStation(state),
  isUserLoggedIn: getIsLoggedIn(state),
  prefersHD: getUserPrefersHDSources(state),
  isPlaying: getIsPlaying(state),
  playerUsesHD: getUseHD(state),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { currentStation, isPlaying, playerUsesHD, isUserLoggedIn, prefersHD } = stateProps;
  return {
    ...ownProps,
    currentStation,
    isHDOn: isPlaying ? playerUsesHD : isUserLoggedIn && prefersHD,
    ...dispatchProps,
  };
};

export default connect(
  mapStateToProps,
  {
    loadStation,
    setUserHDPreference,
    setPlaybackToLiveAudio,
  },
  mergeProps
)(PlayerHDAudio);
